import {withTranslation} from "react-i18next";
import React from "react";
import BackendConnectionService from "../../../ports/backend/backendConnectionService";
import ResponseProcessorService from "../../../ports/backend/ResponseProcessorService";
import LocalStorageService from "../../../ports/localStorage/localStorageService";
import Toastify from "../../alerts/Toastify";
import Swal from 'sweetalert2'
import {toast} from "react-toastify";

class PasaporteForm extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            tagOrDni: "",
            disabled: false,
        }
    }

    updateTagOrDni(e) {
        this.setState({
           tagOrDni: e.target.value
        });
    }

    validatePass(pass) {
        if(pass === "") {
            return "Debe introducir un número de etiqueta o DNI";
        }
        return null;
    }

    triggerAction(action) {
        let {tagOrDni} = this.state;
        let token = LocalStorageService.getUserToken();
        let validate = this.validatePass(tagOrDni);
        if(validate == null) {
            if(action === "mark") {
                this.markRegistry(tagOrDni, token);
            }
            if(action === "delete") {
                this.deleteRegistry(tagOrDni, token);
            }
            this.setState({
                disabled: true
            });
        } else {
            Toastify.error(toast, validate);
        }
    }

    enableButton() {
        this.setState({
            disabled: false
        });
    }

    markRegistry(registry, token) {
        Swal.fire({
            title: 'Confirmación',
            text: "Está a punto de marcar un pasaporte con DNI o etiqueta " + registry + " como recogido ¿Está seguro?",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Recoger pasaporte',
            cancelButtonText: 'Cancelar'
        }).then((result) => {
            if (result.isConfirmed) {
                BackendConnectionService.markPasaporte(token, registry)
                    .then(() => {
                        Toastify.success(toast, "Se ha actualizado el registro correctamente");
                    }).catch((err) => {
                        ResponseProcessorService.processError(err);
                    }).finally(() => {
                        this.enableButton();
                    });
            }
        })
    }

    deleteRegistry(registry, token) {
        Swal.fire({
            title: 'Confirmación',
            text: "Está a punto de eliminar un pasaporte con DNI o etiqueta " + registry + " del sistema. Esto no puede revertirse ¿Está seguro?",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Eliminar registro',
            cancelButtonText: 'Cancelar'
        }).then((result) => {
            if (result.isConfirmed) {
                BackendConnectionService.deletePasaporte(token, registry)
                    .then(() => {
                        Toastify.success(toast, "Se ha eliminado el registro correctamente");
                    }).catch((err) => {
                        ResponseProcessorService.processError(err);
                    }).finally(() => {
                        this.enableButton();
                    });
            }
        })
    }

    render() {
        let {disabled} = this.state;
        let text = this.props.text;

        if(disabled) text = "Procesando...";
        
        return (
            <div className="row">
                <div className="col-md-6">
                    <div className="form-group mb-4">
                        <label htmlFor="acceso">DNI o Etiqueta</label>
                        <input type="text" className="form-control" id="acceso" onChange={(e) => this.updateTagOrDni(e)}
                            placeholder="MREAC99999999999" value={this.state.tagOrDni} />
                    </div>
                </div>

                <div className="col-md-6 ">
                    <div className="mt-4">
                        <button
                            className="btn btn-success btn-block waves-effect waves-light"
                            type="button" onClick={() => this.triggerAction(this.props.action)} disabled={disabled}>{text}
                        </button>
                    </div>
                </div>
            </div>
        );
    }
}
export default withTranslation()(PasaporteForm);